import React, { useState } from 'react'
import { DRONE_NAMES, GLOBAL_STYLES } from '../../../appConstants'
import more from "../../../assets/more.png"
import eVotol from "../../../assets/eVotol.png"
import quadcoptor from '../../../assets/quadcoptor.png'
import hexacopter from '../../../assets/hexacopter.png'
import { reduceLongName } from '../../../ReusableFunctions/reusableFunctions'
import Tippy from '@tippyjs/react'
import { OptionMenu } from '../../../Components/Helper'
import CustomTooltip from '../../../ReusableComponents/CustomTooltip'

const DroneComponent = ({ drone, onDroneEdit, onDroneDelete }) => {
    const [activityPopup, setActivityPopup] = useState({
        id: null,
        isOpen: false
    })
    const openActicityPopup = (id) => {
        setActivityPopup((prev) => ({
            id: id,
            isOpen: prev.id !== id || !prev.isOpen, // Close the current popup and open the clicked row
        }));
    }
    return (
        <>
            <div style={{ padding: "10px", borderRadius: "20px", background: "#FCFCFC", height: "285px" }}>
                <div style={{ display: "flex", flexDirection: "row-reverse", alignItems: "center", position: "relative" }}>
                    <Tippy offset={[10, -15]} interactive onShown={(instance) => {
                        document.querySelector('[data-tippy-root]').addEventListener('click', event => {
                            instance.hide();
                        })
                    }} className='tippy' trigger='click' arrow={false} content={
                        <OptionMenu
                            isLeft
                            onClickDelete={() => {
                                onDroneDelete(drone.id)
                            }}
                            onClickEdit={() => {
                                onDroneEdit(drone.id);
                            }}
                        />
                    }>
                        <img src={more} alt="three dot" style={{ width: "22px", color: GLOBAL_STYLES.INACTIVE_GREY_COLOR, cursor: "pointer", position: "absolute", top: "5px", right: "5px" }} onClick={() => { openActicityPopup(drone?.id) }} />
                    </Tippy>
                </div>
                <div style={{ display: "flex", gap: "30px", marginLeft: "20px", alignItems: "center", paddingTop: "15px", fontFamily: "Manrope", marginTop: "5px" }}>
                    <div style={{ backgroundColor: "white", borderRadius: "50%", border: "1px solid #BFC8D9", padding: "5px" }}>
                        <img style={{ padding: "15px", width: "85px", height: "85px", borderRadius: drone.type === DRONE_NAMES.eVTOLS || drone.type === DRONE_NAMES.Hexacopter || drone.type === DRONE_NAMES.Quadcopters ? "" : "50%" }} src={drone.type === DRONE_NAMES.eVTOLS ? eVotol : drone.type === DRONE_NAMES.Hexacopter ? hexacopter : drone.type === DRONE_NAMES.Quadcopters ? quadcoptor : `https://ui-avatars.com/api/?background=727272&color=fff&name=${drone?.type?.split(" ").join("+")}`} alt="Profile pic" />
                    </div>
                    <div>
                        <p style={{ fontWeight: "500", fontSize: "19px", lineHeight: "24px", color: "#0845C0" }}>{drone.type}</p>
                        <p style={{ fontSize: "14px", color: "#3B3B3B", marginTop: "2px" }}>{drone.location_name || "-"}</p>
                    </div>
                </div>
                <div style={{ padding: "25px 0px 0px 20px" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", alignItems: "center", rowGap: "8px", columnGap: "50px", padding: "10px 9px", color: "#3B3B3B" }}>
                        <div>
                            <Tippy allowHTML={true} content={<CustomTooltip content={drone.manufacturer} />} placement="top-start">
                                <div style={{ fontSize: "16px", fontWeight: "500" }}>{drone.manufacturer ? reduceLongName(drone.manufacturer, 12) : "-"}</div>
                            </Tippy>
                            <p style={{ fontSize: "12px", color: GLOBAL_STYLES.FONT_COLOR_SUB, fontWeight: 400 }}>(Manufacturer)</p>
                        </div>
                        <div>
                            <Tippy allowHTML={true} content={<CustomTooltip content={drone.drone_uin} />} placement="top-start">
                                <div style={{ fontSize: "16px", fontWeight: "500" }}>{drone.drone_uin ? reduceLongName(drone.drone_uin, 12) : "-"}</div>
                            </Tippy>
                            <p style={{ fontSize: "12px", color: GLOBAL_STYLES.FONT_COLOR_SUB, fontWeight: 400 }}>(UIN)</p>
                        </div>
                        <div>
                            <Tippy allowHTML={true} content={<CustomTooltip content={drone.model_name} />} placement="top-start">
                                <div style={{ fontSize: "16px", fontWeight: "500" }}>{drone.model_name ? reduceLongName(drone.model_name, 12) : "-"}</div>
                            </Tippy>
                            <p style={{ fontSize: "12px", color: GLOBAL_STYLES.FONT_COLOR_SUB, fontWeight: 400 }}>(Model)</p>
                        </div>
                        <div>
                            <div style={{ fontSize: "16px", fontWeight: "500" }}>{drone.service_type || '-'}</div>
                            <p style={{ fontSize: "12px", color: GLOBAL_STYLES.FONT_COLOR_SUB, fontWeight: 400 }}>(Services)</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DroneComponent